module.exports = __webpack_public_path__ + "static/media/ceilings_material_60y_y.a47cac21.csv";